import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-numeric-keypad',
    templateUrl: './numeric-keypad.component.html',
    styleUrls: ['./numeric-keypad.component.css']
})
export class NumericKeypadComponent implements OnInit {

    @Output() digit = new EventEmitter<string>();

    constructor() { }

    ngOnInit(): void {
    }

    emit(val: string) {
        this.digit.emit(val);
    }
}
